export type DateFormat =
    | "dd.MM.yyyy"
    | "dd.MM.yyyy hh:mm"
    | "dd/MM/yyyy"
    | "dd/MM/yyyy hh:mm"
    | "MM/dd/yyyy"
    | "MM/dd/yyyy hh:mm"
    | "dd-MM-yyyy"
    | "dd-MM-yyyy hh:mm"
    | "yyyy-MM-dd"
    | "yyyy-MM-dd hh:mm"
    | "MM/yyyy"
    | "MM.yyyy";

export interface FormatDateConfig {
    date: DateFormat;
    shortDate: DateFormat;
}
export const DEFAULT_FORMAT_DATE_CONFIG: FormatDateConfig = {
    date: "dd/MM/yyyy",
    shortDate: "MM/yyyy",
};
